import React from 'react'
import {createIcon} from '@chakra-ui/react'

export const HourglassIcon = createIcon({
  displayName: 'HourglassIcon',
  viewBox: '0 0 24 24',
  path: (
    <path
      d="M6 2L6.01 8L10 12L6.01 16.01L6 22H18V16L14 12L18 8.01V2H6ZM16 16.5V20H8V16.5L12 12.5L16 16.5Z"
      fill="currentColor"
    />
  ),
})
